import { SelectBuildOption, selectOptionTools } from 'common/tools/select-option-tools';
import { BodyTypeValues } from 'common/types/body-type';
import { ColorType, ColorTypeValues } from 'common/types/color-type';
import { ConditionType, ConditionTypeValues } from 'common/types/condition-type';
import { CylinderTypeValues } from 'common/types/cylinder-type';
import { DoorTypeValues } from 'common/types/door-type';
import { DrivetrainTypeValues } from 'common/types/drivetrain-type';
import { FuelTypeValues } from 'common/types/fuel-type';
import { MileageRange, MileageRangeValues } from 'common/types/mileage-range';
import { TitleStatus, TitleStatusValues } from 'common/types/title-status';
import { TransmissionTypeValues } from 'common/types/transmission-type';
import { BodyType, CylinderType, DoorType, DrivetrainType, FuelType, TransmissionType } from 'graphql/generated';
import React from 'react';

export const selectBodyTypeOptions = (buildOption?: SelectBuildOption) =>
  selectOptionTools.build(BodyType, BodyTypeValues, buildOption);

export const selectTitleStatusOptions = (buildOption?: SelectBuildOption) =>
  selectOptionTools.build(TitleStatus, TitleStatusValues, buildOption);

export const selectColorTypeOptions = (buildOption?: SelectBuildOption) =>
  selectOptionTools.build(ColorType, ColorTypeValues, buildOption);

export const selectConditionTypeOptions = (buildOption?: SelectBuildOption) =>
  selectOptionTools.build(ConditionType, ConditionTypeValues, buildOption);

export const selectCylinderTypeOptions = (buildOption?: SelectBuildOption) =>
  selectOptionTools.build(CylinderType, CylinderTypeValues, buildOption);

export const selectDoorTypeOptions = (buildOption?: SelectBuildOption) =>
  selectOptionTools.build(DoorType, DoorTypeValues, buildOption);

export const selectDrivetrainTypeOptions = (buildOption?: SelectBuildOption) =>
  selectOptionTools.build(DrivetrainType, DrivetrainTypeValues, buildOption);

export const selectFuelTypeOptions = (buildOption?: SelectBuildOption) =>
  selectOptionTools.build(FuelType, FuelTypeValues, buildOption);

export const selectMileageRangeOptions = (buildOption?: SelectBuildOption) =>
  selectOptionTools.build(MileageRange, MileageRangeValues, buildOption);

export const selectTransmissionTypeOptions = (buildOption?: SelectBuildOption) =>
  selectOptionTools.build(TransmissionType, TransmissionTypeValues, buildOption);

export const selectDistanceOptions = [
  {
    id: '10',
    label: '10 miles from:',
  },
  {
    id: '25',
    label: '25 miles from:',
  },
  {
    id: '50',
    label: '50 miles from:',
  },
  {
    id: '75',
    label: '75 miles from:',
  },
  {
    id: '100',
    label: '100 miles from:',
  },
  {
    id: '200',
    label: '200 miles from:',
  },
  {
    id: '300',
    label: '300 miles from:',
  },
  {
    id: '400',
    label: '400 miles from:',
  },
  {
    id: '500',
    label: '500 miles from:',
  },
  {
    id: '*',
    label: 'Any distance from:',
  },
];
